import Vue from 'vue';
import dayjs from 'dayjs';

const formatDate = value =>
    value ? dayjs(value).format('DD/MM/YY | HH:mm') : '';

Vue.filter('formatDate', formatDate);
